import { CommunicationEngineConfigs, FrameworkOperationKeys } from '@bcp-nextgen-dx-touchpoint-framework/react-js';

import { ApiConfig } from '../envVarsValues';

export const BusinessOperationKeys = {
	clickToCallAgentClosed: 'clickToCallAgentClosed',
	clickToCallAgentOpen: 'clickToCallAgentOpen',
	clickToCallAllInternationalDialingPhoneCodes: 'clickToCallAllInternationalDialingPhoneCodes',
	clickToCallIsOpen: 'clickToCallIsOpen',
	clickToCallStatus: 'clickToCallStatus',
	retrieveAccounts: 'retrieveAccounts',
	retrieveContext: 'retrieveContext',
	retrieveDocumentsReference: 'retrieveDocumentsReference',
	retrieveResourcesByListAndArea: 'retrieveResourcesByListAndArea',
	retrieveCountries: 'retrieveCountries',
	aliasAuthenticationType: 'aliasAuthenticationType',
	aliasAuthenticationMessage: 'aliasAuthenticationMessage',
	subscription: 'subscription',
	retrieveCompany: 'retrieveCompany',
};

export type TBusinessOperationKeys = keyof typeof BusinessOperationKeys;

const communicationEngineConfigs: CommunicationEngineConfigs = {
	defaultEndpoint:
		(process.env.REACT_APP_MOCK_START as string) === 'true'
			? (process.env.REACT_APP_API_URL as string)
			: ApiConfig.url,
	defaultProtocol: 'json/rpc',
	defaultHeaders: {
		accept: ApiConfig.headers.accept,
		'content-type': ApiConfig.headers['content-type'],
	},

	businessOperations: {
		[BusinessOperationKeys.clickToCallAgentClosed]: {
			url: 'api/rpc/ClickToCallAgentClosed',
		},
		[BusinessOperationKeys.clickToCallAgentOpen]: {
			url: 'api/rpc/ClickToCallAgentOpen',
		},
		[BusinessOperationKeys.clickToCallAllInternationalDialingPhoneCodes]: {
			url: 'api/rpc/ClickToCallAllInternationalDialingPhoneCodes',
		},
		[BusinessOperationKeys.clickToCallIsOpen]: {
			url: 'api/rpc/ClickToCallIsOpen',
		},
		[BusinessOperationKeys.clickToCallStatus]: {
			url: 'api/rpc/ClickToCallStatus',
		},
		[BusinessOperationKeys.retrieveAccounts]: {
			url: 'api/rpc/RetrieveAccounts',
		},
		[BusinessOperationKeys.retrieveContext]: {
			url: 'api/rpc/RetrieveContext',
		},
		[BusinessOperationKeys.retrieveDocumentsReference]: {
			url: 'api/rpc/RetrieveDocumentsReference',
		},
		[BusinessOperationKeys.retrieveResourcesByListAndArea]: {
			url: 'api/rpc/RetrieveResourcesByListAndArea',
		},
		[BusinessOperationKeys.retrieveCountries]: {
			url: 'api/rpc/RetrieveCountries',
		},
		[BusinessOperationKeys.aliasAuthenticationMessage]: {
			url: 'api/rpc/AliasAuthenticationMessage',
		},
		[BusinessOperationKeys.aliasAuthenticationType]: {
			url: 'api/rpc/AliasAuthenticationType',
		},
		[BusinessOperationKeys.subscription]: {
			url: 'api/rpc/Subscription',
		},
		[BusinessOperationKeys.retrieveCompany]: {
			url: 'api/rpc/RetrieveCompany',
		},
	},

	frameworkOperations: {
		[FrameworkOperationKeys.InteractionEngineRequest]: {
			url: '/api/rpc/WriteChannelTouchPointUserInteractions',
		},
		[FrameworkOperationKeys.RetrieveRemoteConfiguration]: {
			url: '/api/rpc/RetrieveTPFOperationalConfigs',
		},
		[FrameworkOperationKeys.LoggingService]: {
			url: '/api/rpc/WriteApplicationalLogging',
		},
		[FrameworkOperationKeys.PersonalizationEngineRequest]: {
			url: '/api/rpc/RetrievePersonalization',
		},
		[FrameworkOperationKeys.TemplateEngineRequestTemplate]: {
			url: '/api/rpc/RetrieveUiComplexPrism',
		},
	},
};

export default communicationEngineConfigs;
